import { html, property } from 'lit-element'
import { repeat } from 'lit-html/directives/repeat'
import globalSearchActions from './global-search-actions.styles.scss'
import { ShellElement } from '../../../common/shell-element'
import { executeCommand } from '../../../services/namespaces'
import type { GlobalSearchActionUI } from '../global-search-models'
import type { GlobalSearchResult } from '../../../extensions'
import isEmpty from 'lodash.isempty'

export interface GlobalSearchActionsProps {
  readonly actions: readonly GlobalSearchActionUI[]
  readonly originalResult?: GlobalSearchResult
  readonly searchString: string
}
export class GlobalSearchActions extends ShellElement implements GlobalSearchActionsProps {
  static readonly tagName = 'goto-global-search-actions'

  @property({ type: Array }) actions: GlobalSearchActionsProps['actions'] = []
  @property({ type: Array }) originalResult?: GlobalSearchActionsProps['originalResult'] = {}
  @property({ type: String }) searchString: GlobalSearchActionsProps['searchString'] = ''

  static get styles() {
    return globalSearchActions
  }

  private convertToParams() {
    const params: unknown[] = [this.searchString]
    if (!isEmpty(this.originalResult)) {
      params.unshift(this.originalResult)
    }
    return params
  }

  renderAction(action: GlobalSearchActionUI) {
    return html`
      <chameleon-round-button
        class="action-button"
        variant="secondary"
        @click=${(event: MouseEvent) => {
          event.stopPropagation()
          executeCommand(action.command, this.convertToParams())
        }}
        aria-label=${action.displayName}
        ><chameleon-svg slot="end" class="left">${action.icon}</chameleon-svg>
      </chameleon-round-button>
    `
  }

  render() {
    return html`
      ${repeat(
        this.actions,
        action => action.id,
        action => this.renderAction(action),
      )}
    `
  }
}

declare global {
  interface HTMLElementTagNameMap {
    readonly [GlobalSearchActions.tagName]: GlobalSearchActions
  }
}
